/*
 * Shared scripts for custom main-product blocks ported from the client's
 * customizer (custom_liquid) blocks. One file for all custom blocks.
 * Loaded by sections/main-product.liquid when a custom block is present.
 *
 * The al_product_badges block needs no JS — this file is the shared home for
 * later blocks that do (e.g. the PDF "evidence" modal, the delivery countdown).
 * Add each block's behaviour below, ideally as small, self-initialising modules.
 */
/* al_delivery_combined — live "order in the next X / get by Y" estimate.
   Self-initialising; updates every block with [data-al-delivery-estimate]. */
(function () {
  'use strict';

  var TIME_ZONE = 'Europe/Sofia';
  var CUTOFF_HOUR = 12;

  var dayNames = ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота'];
  var monthNames = ['януари', 'февруари', 'март', 'април', 'май', 'юни', 'юли', 'август', 'септември', 'октомври', 'ноември', 'декември'];

  function getSofiaParts(date) {
    var formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    });
    var parts = formatter.formatToParts(date).reduce(function (acc, part) { acc[part.type] = part.value; return acc; }, {});
    var year = Number(parts.year);
    var month = Number(parts.month);
    var day = Number(parts.day);
    return {
      year: year, month: month, day: day,
      hour: Number(parts.hour), minute: Number(parts.minute), second: Number(parts.second),
      weekday: new Date(Date.UTC(year, month - 1, day)).getUTCDay()
    };
  }

  function addDays(dateParts, amount) {
    var date = new Date(Date.UTC(dateParts.year, dateParts.month - 1, dateParts.day + amount));
    return { year: date.getUTCFullYear(), month: date.getUTCMonth() + 1, day: date.getUTCDate(), weekday: date.getUTCDay() };
  }

  function isCutoffDay(dateParts) { return dateParts.weekday >= 1 && dateParts.weekday <= 5; }
  function isDeliveryDay(dateParts) { return dateParts.weekday >= 1 && dateParts.weekday <= 6; }

  function nextCutoffDay(fromDateParts) {
    var date = fromDateParts;
    do { date = addDays(date, 1); } while (!isCutoffDay(date));
    return date;
  }

  function nextDeliveryDay(fromDateParts) {
    var date = fromDateParts;
    do { date = addDays(date, 1); } while (!isDeliveryDay(date));
    return date;
  }

  function getTimezoneOffsetMs(date, timeZone) {
    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    });
    var parts = formatter.formatToParts(date).reduce(function (acc, part) { acc[part.type] = part.value; return acc; }, {});
    var asUTC = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute), Number(parts.second));
    return asUTC - date.getTime();
  }

  function makeSofiaDate(year, month, day, hour, minute, second) {
    var utcGuess = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    var offset = getTimezoneOffsetMs(utcGuess, TIME_ZONE);
    return new Date(Date.UTC(year, month - 1, day, hour, minute, second) - offset);
  }

  function getDeliveryData() {
    var now = new Date();
    var sofiaNow = getSofiaParts(now);
    var beforeCutoff = sofiaNow.hour < CUTOFF_HOUR;
    var todayIsCutoffDay = isCutoffDay(sofiaNow);
    var cutoffDate, deliveryDate;
    if (todayIsCutoffDay && beforeCutoff) {
      cutoffDate = sofiaNow;
      deliveryDate = nextDeliveryDay(sofiaNow);
    } else {
      cutoffDate = nextCutoffDay(sofiaNow);
      deliveryDate = nextDeliveryDay(cutoffDate);
    }
    var cutoffDateTime = makeSofiaDate(cutoffDate.year, cutoffDate.month, cutoffDate.day, CUTOFF_HOUR, 0, 0);
    return { cutoffDateTime: cutoffDateTime, deliveryDate: deliveryDate };
  }

  function formatCountdown(ms) {
    if (ms < 0) ms = 0;
    var totalMinutes = Math.floor(ms / 60000);
    var days = Math.floor(totalMinutes / 1440);
    var hours = Math.floor((totalMinutes % 1440) / 60);
    var minutes = totalMinutes % 60;
    if (days > 0) return days + 'д ' + hours + 'ч ' + minutes + 'м';
    if (hours > 0) return hours + 'ч ' + minutes + 'м';
    return minutes + 'м';
  }

  function formatDeliveryDate(dateParts) {
    return dayNames[dateParts.weekday] + ', ' + dateParts.day + ' ' + monthNames[dateParts.month - 1];
  }

  function updateDeliveryBlocks() {
    var blocks = document.querySelectorAll('[data-al-delivery-estimate]');
    if (!blocks.length) return;
    var data = getDeliveryData();
    var countdown = formatCountdown(data.cutoffDateTime.getTime() - Date.now());
    var deliveryDate = formatDeliveryDate(data.deliveryDate);
    blocks.forEach(function (block) {
      var countdownEl = block.querySelector('[data-al-delivery-countdown]');
      var deliveryDateEl = block.querySelector('[data-al-delivery-date]');
      if (countdownEl) countdownEl.textContent = countdown;
      if (deliveryDateEl) deliveryDateEl.textContent = deliveryDate;
    });
  }

  updateDeliveryBlocks();
  setInterval(updateDeliveryBlocks, 60000);
})();

/* AL+ Omnibus price - synchronized with the native Nimbus variant update */
(function () {
  'use strict';

  if (window.ALPlusOmnibusNimbusSyncInitialized) {
    return;
  }

  window.ALPlusOmnibusNimbusSyncInitialized = true;

  var BLOCK_SELECTOR = '[data-al-omnibus-price]';
  var connectAttempts = 0;
  var maxConnectAttempts = 200;

  function setBlockVisibility(block, shouldShow, formattedPrice) {
    if (!block) {
      return;
    }

    var valueElement = block.querySelector(
      '[data-al-omnibus-value]'
    );

    if (valueElement) {
      valueElement.textContent = shouldShow
        ? formattedPrice
        : '';
    }

    block.hidden = !shouldShow;
    block.setAttribute(
      'aria-hidden',
      shouldShow ? 'false' : 'true'
    );

    var wrapper = block.parentElement;

    if (wrapper) {
      wrapper.hidden = !shouldShow;
    }
  }

  function updateFromNimbusHtml(event) {
    var eventData =
      event && event.data
        ? event.data
        : null;

    if (!eventData || !eventData.html) {
      return;
    }

    var sectionId = eventData.sectionId;
    var updatedDocument = eventData.html;

    var updatedBlock =
      updatedDocument.querySelector(BLOCK_SELECTOR);

    var productInfo = sectionId
      ? document.getElementById(
          'ProductInfo-' + sectionId
        )
      : null;

    var currentRoot = productInfo || document;
    var currentBlocks =
      currentRoot.querySelectorAll(BLOCK_SELECTOR);

    if (!currentBlocks.length) {
      return;
    }

    var shouldShow = Boolean(
      updatedBlock &&
      !updatedBlock.hasAttribute('hidden')
    );

    var formattedPrice = '';

    if (shouldShow) {
      var updatedValue = updatedBlock.querySelector(
        '[data-al-omnibus-value]'
      );

      if (updatedValue) {
        formattedPrice =
          updatedValue.textContent.trim();
      }

      shouldShow = formattedPrice !== '';
    }

    currentBlocks.forEach(function (block) {
      setBlockVisibility(
        block,
        shouldShow,
        formattedPrice
      );
    });
  }

  function connectToNimbus() {
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.variantChange
    ) {
      if (
        window.ALPlusOmnibusNimbusSubscriberAttached
      ) {
        return;
      }

      window.ALPlusOmnibusNimbusSubscriberAttached =
        true;

      subscribe(
        PUB_SUB_EVENTS.variantChange,
        updateFromNimbusHtml
      );

      return;
    }

    connectAttempts += 1;

    if (connectAttempts < maxConnectAttempts) {
      window.setTimeout(
        connectToNimbus,
        50
      );
    } else {
      console.warn(
        'AL+ Omnibus could not connect to the Nimbus variant event.'
      );
    }
  }

  connectToNimbus();

  document.addEventListener(
    'shopify:section:load',
    function () {
      connectToNimbus();
    }
  );
})();